import ExtensionManager from './ExtensionManager';
import MODULE_TYPES from './MODULE_TYPES';

const DEFAULT_EXPORTS = {
  ExtensionManager,
  MODULE_TYPES,
};

export default DEFAULT_EXPORTS;

export { ExtensionManager, MODULE_TYPES };
